import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  ButtonGroup,
} from "../../components/ui";
import { Link } from "react-router-dom";
import { getPostShortList, deletePost } from "../../api";
import { formatToLocalDate } from "../../utils";
import Search from "./search";
import debounce from "lodash/debounce";
import TableHeader from "./tableHeader";
import { DotLoader } from "react-spinners";
import publisherStore from "../../flux/publisherStore";

class Cms extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      posts: [],
      currentPage: 0,
      filters: {
        title: "",
        authorId: null,
      },
    };
  }

  componentDidMount = async () => {
    this.setState({ loading: true });
    this.fetchPosts(0);
    document.addEventListener("scroll", this.trackScrolling);
  };

  isBottom(el) {
    return el && el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  componentWillUnmount = () => {
    document.removeEventListener("scroll", this.trackScrolling);
  };

  trackScrolling = async () => {
    const wrappedElement = document.getElementById("posts-list");
    if (this.isBottom(wrappedElement)) {
      document.removeEventListener("scroll", this.trackScrolling);
      let nextPage = this.state.currentPage + 1;
      const posts = await getPostShortList(50, nextPage, this.state.filters);
      let temp = this.state.posts;
      const newPosts = posts && posts.data && posts.data.items;
      let updated = temp.concat(newPosts || []);
      this.setState(
        {
          posts: updated,
          currentPage: nextPage,
        },
        () => {
          document.addEventListener("scroll", this.trackScrolling);
        }
      );
    }
  };

  fetchPosts = debounce(async (page = 0) => {
    const posts = await getPostShortList(50, page, this.state.filters);
    this.setState({ posts: posts ? posts.data.items : [], loading: false });
  }, 500);

  onSearch = async (title) => {
    this.setState(
      { filters: { ...this.state.filters, title }, currentPage: 0 },
      () => this.fetchPosts()
    );
  };

  deletePost = async (postId) => {
    const res = await deletePost(postId);
    this.setState({
      postDeleted: true,
    });
    window.location.reload();
  };

  applyPublisherFilter = (publisherId) => {
    const isSelectedPublisher = publisherId === this.state.filters.authorId;
    this.setState(
      {
        filters: {
          ...this.state.filters,
          authorId: isSelectedPublisher ? null : publisherId,
        },
      },
      () => this.fetchPosts()
    );
  };

  isUserAdmin = () => {
    const user = localStorage.getItem("user");
    const parsedUser = user && JSON.parse(user);
    const isAdmin = parsedUser && parsedUser.userRoleId === 1;
    return isAdmin;
  };

  render() {
    return this.state.loading ? (
      <div className="mainLoaderBlock">
        <DotLoader color="#36d7b7" />
        <label style={{ marginTop: 30 }}>Loading your content...</label>
      </div>
    ) : (
      <Container
        style={{ marginTop: window.screen.width > 767 ? 35 : {} }}
        fluid
        className="main-content-container px-4"
      >
        <Row noGutters className="page-header py-4">
          <Col lg={12}></Col>
          <Col lg={12}>
            <Card small className="boxCard">
              <h2 className="mt-3 ml-3">CMS</h2>
              <CardHeader className="border-bottom">
                <Search
                  onSearch={this.onSearch}
                  title={this.state.filters.title}
                />
                {this.isUserAdmin() ? (
                  <div
                    className="filters text-right mt-4"
                    style={{ justifyContent: "flex-start" }}
                  >
                    {(publisherStore.getPublishers() || [])
                      .filter((p) => p.isHidden === false)
                      .map((publisher, index) => (
                        // eslint-disable-next-line jsx-a11y/anchor-is-valid
                        <a
                          href="#"
                          key={index}
                          title={publisher.name}
                          className={
                            this.state.filters.authorId === publisher.id
                              ? "selected card-post__author-avatar card-post__author-avatar--small"
                              : "card-post__author-avatar card-post__author-avatar--small"
                          }
                          onClick={() =>
                            this.applyPublisherFilter(publisher.id)
                          }
                        >
                          <img
                            src={publisher.avatar.small}
                            alt={publisher.name}
                          />
                        </a>
                      ))}
                  </div>
                ) : null}
              </CardHeader>
              <CardBody className="p-0 pb-3">
                <table id="posts-list" className="table mb-0 cms-table">
                  <TableHeader isAdmin={this.isUserAdmin()} />
                  <tbody>
                    {this.state.posts.map((post) => (
                      <tr>
                        <td>{post.id}</td>
                        <td>{post.title}</td>
                        <td>{post.slug}</td>
                        <td>{post.numViews ? post.numViews : "-"}</td>
                        <td>{post.isDraft ? "Draft" : "Published"}</td>
                        {this.isUserAdmin() ? <td>{post.author.name}</td> : ""}
                        <td>{formatToLocalDate(post.publishedAt)}</td>
                        <td>
                          <ButtonGroup size="sm">
                            <Button
                              theme="white"
                              onClick={() => this.deletePost(post.id)}
                            >
                              <span className="text-danger">
                                <i className="material-icons">clear</i>
                              </span>{" "}
                              Delete
                            </Button>
                            <Link
                              className="btn btn-primary"
                              to={`/edit-post/${post.id}`}
                            >
                              Edit
                            </Link>
                          </ButtonGroup>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Cms;
